import { render } from "./ProjectStatusCard.vue?vue&type=template&id=0322ee24&scoped=true"
import script from "./ProjectStatusCard.vue?vue&type=script&lang=js"
export * from "./ProjectStatusCard.vue?vue&type=script&lang=js"

import "./ProjectStatusCard.vue?vue&type=style&index=0&id=0322ee24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0322ee24"]])

export default __exports__